"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = exports.createLogger = void 0;
const winston_1 = __importDefault(require("winston"));
const defaultOptions = {
    level: "info",
    format: winston_1.default.format.combine(winston_1.default.format.timestamp(), winston_1.default.format.json()),
    transports: [
        new winston_1.default.transports.Console({ format: winston_1.default.format.json() }),
    ],
};
const createLogger = (options) => {
    return winston_1.default.createLogger(Object.assign(Object.assign({}, defaultOptions), options));
};
exports.createLogger = createLogger;
const log = createLogger();
exports.log = log;
